module.exports = __webpack_public_path__ + "img/53.d8d23b28.webp";